import React, { ElementType } from 'react';
import noop from 'lodash/noop';

import { IntegrationTags } from '@domain/integrations/integrations-list/integration-tags/integration-tags';
import { Tag } from '@shared/pareto-workflows/tags/tags.types';
import * as S from './integration-slot.styles';

type ImageOrIcon = { image: string; icon?: never } | { image?: never; icon: JSX.Element }

type Props = {
    title: string
    subtitle?: string
    isDisabled: boolean
    testId?: string
    isIntegrated?: boolean
    onClick?: Function
    className?: string
    dataAppcuesId?: string;
    tags: Tag[];
} & ImageOrIcon

export const IntegrationSlot: ElementType<Props> = ({
    isDisabled,
    isIntegrated = false,
    testId = 'integration-slot',
    image,
    icon,
    title,
    subtitle,
    onClick = noop,
    className = '',
    dataAppcuesId,
    tags,
}: Props) => (
    <S.Item
        className={className}
        disabled={isDisabled}
        data-testid={testId}
        data-appcues-id={dataAppcuesId}
        onClick={isDisabled ? noop : onClick}
    >
        <IntegrationTags tags={tags} />
        <S.ImageWrapper disabled={isDisabled}>
            {image && <S.Image alt="Integration Icon" src={image} />}
            { icon }
        </S.ImageWrapper>

        <S.Title>{title}</S.Title>
        <S.Subtitle isIntegrated={isIntegrated} disabled={isDisabled}>
            { subtitle }
        </S.Subtitle>
    </S.Item>
);
